import React, { useEffect, useState } from 'react'

//componentes
import EncabezadoComponent from '../../Components/Encabezado/encabezado.component'
import CabezoteComponent from '../../Components/Cabezote/cabezote.component'
import PasoPasoComponent from '../../Components/PasoPaso/pasoPaso.component'
import BannerComponent from '../../Components/Banner/banner.component'
import CategoriasComponent from '../../Components/Categorias/categorias.page'
import Footer from '../../Components/Footer/Footer.components';
/* import ModalSucursales from '../../Components/Sucursal/modalSucursales.component'; */
import * as constant from '../../global/const'
//axios
import axios from 'axios'
import GridAccesoRapido from '../../Components/AccesoRapido/gridAccesoRapido.component'

const HomePage = (props) => {
    const [orden, setorden] = useState([])
    const [open, setOpen] = useState(false);
    const [close, setclose] = useState(true);
    const [mostrarOpciones, setMostrarOpciones] = useState(false);

    const getOrderComponents = () => {
        axios.get(constant.GETCOMPONENTS + "?tipo=1").then((response) => {
            setorden(response.data)
        }).catch((err) => {

        })

        //axios
    }

    useEffect(() => {
        getOrderComponents()
    }, [])

    return (
        <div className="home">
            <EncabezadoComponent path="/" desc1={'Inicio'} desc2="Negocios" inicio={true} />
            <CabezoteComponent
                categoriasGlobal={null}
                open={open}
                setOpen={setOpen}
                tipo={false}
                close={close}
                setclose={setclose}
                mostrarOpciones={mostrarOpciones}
                setMostrarOpciones={setMostrarOpciones}
            />
            {orden.length !== 0 ?
                orden.map((tipo, i) => (
                    tipo.descripcion === "Banners" ? <BannerComponent />
                        : tipo.descripcion === "Categorías/Marcas" ? <CategoriasComponent />
                            : tipo.descripcion === "Accesos Rápidos" ? <></>
                                : tipo.descripcion === "Paso a Paso" ? <PasoPasoComponent />
                                    : null
                ))
                : null
            }
            <GridAccesoRapido open={open} setOpen={setOpen} />
            {/* <ModalSucursales/> */}
            <Footer />
        </div>
    )
}

export default HomePage